import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { View } from 'react-native';
import { Button, Paragraph, Dialog, Portal, Provider } from 'react-native-paper';


interface Props {
  title: string;
  text: string;
  isOpen: boolean;
  hideDialog: () => void;
  onCofirmClicked?: () => void;
}


const ConfirmationDialog = ({title, text, isOpen, hideDialog, onCofirmClicked} : Props) => {
  // Translate :
  const {t, i18n} = useTranslation();
  return (
    <View>
      <Portal>
        <Dialog visible={isOpen} onDismiss={hideDialog}>
          <Dialog.Title>{title}</Dialog.Title>
          <Dialog.Content>
            <Paragraph>{text}</Paragraph>
          </Dialog.Content>
          <Dialog.Actions>
            <Button onPress={hideDialog}>{t("cancelCD")}</Button>
            <Button onPress={onCofirmClicked}>{t("confirmCD")}</Button>
          </Dialog.Actions>
        </Dialog>
      </Portal>
    </View>
  );
};

export default ConfirmationDialog;
